import { IAction } from "reduxsauce";
import { CourseAuthorActions } from "../actions/course-author/course-author";
import { dashboardActions } from "../actions/dashboard/dashboard.actions";
import { mergeActionDefinitions } from "../utils";
import classAnalyticsActions from "./Analytics/ClassAnalytics/actions";
import exportUsersActions from "./Analytics/Common/actions";
import scormPackageAnalyticsActions from "./Analytics/ScormPackageAnalytics/actions";
import classesActions from "./Classes/actions";
import coursesActions from "./Courses/actions";
import selectOrganizationActions from "./SelectOrganization/actions";

export default mergeActionDefinitions(
  "App",
  {
    fetchLocalAuthentication: [],
    handleFetchLocalAuthenticationSuccess: ["authenticationState", "user", "organization", "objectsAmount"],
    handleLoginFailure: ["error"],
    handleLoginSuccess: ["user", "organization"],
    handleLogoutSuccess: [],
    login: ["data"],
    logout: [],
    mount: [],
    printCurrentPage: [],
    unmount: [],
  },
  classAnalyticsActions,
  classesActions,
  coursesActions,
  CourseAuthorActions,
  dashboardActions,
  selectOrganizationActions,
  scormPackageAnalyticsActions,
  exportUsersActions
);

export const INITIAL_OBJECT_AMOUNT = "...";

export type ObjectAmount = string | number;

export interface IAmountAction extends IAction {
  amount: ObjectAmount;
}

export interface IObjectsAmount {
  courseAmount: ObjectAmount;
  classAmount: ObjectAmount;
  exportedScormPackagesAmount: ObjectAmount;
  groupsAmount: ObjectAmount;
  usersAmount: ObjectAmount;
}
